module.exports = __webpack_public_path__ + "static/media/leydeamnistia_art.be4e2dd2.jpg";